var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-div"},[_c('Poptip',{attrs:{"word-wrap":"","width":_vm.width,"content":_vm.content,"trigger":"hover","placement":"right"}},[_c('Icon',{attrs:{"type":"ios-alert-outline","size":"14"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }